export const CapeMark = ({ size = 34, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M32 7 C36.5 7 40 9 42 12 L50 49 Q32 59 14 49 L22 12 C24 9 27.5 7 32 7 Z"
      stroke="#D4AF37"
      strokeWidth="2.5"
    />
    <path d="M32 13 L32 52" stroke="#D4AF37" strokeWidth="1.4" />
    <circle cx="21" cy="46.5" r="1.6" fill="#D4AF37" />
    <circle cx="32" cy="51.5" r="1.6" fill="#D4AF37" />
    <circle cx="43" cy="46.5" r="1.6" fill="#D4AF37" />
  </svg>
);
